( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( 'LotUnallocateModalController', LotUnallocateModalController );

    LotUnallocateModalController.$inject = ['$uibModalInstance', 'myLots', 'ToastrService', 'LotCustomService'];

    function LotUnallocateModalController($uibModalInstance,  myLots, ToastrService, LotCustomService) {
        var vm = this;

        vm.lots = myLots;
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            LotCustomService.releaseLots( vm.lots ).then( function( response ) {
                ToastrService.success("Release Lots to Stock Success!", "Success!");
                $uibModalInstance.close( response );
            }, function( error ) {
                ToastrService.error( "Something went wrong", "Error!" );
            });
        }
    }
})();
